import { render, staticRenderFns } from "./messagesCounter.vue?vue&type=template&id=7cee4c26&"
import script from "./messagesCounter.vue?vue&type=script&lang=ts&"
export * from "./messagesCounter.vue?vue&type=script&lang=ts&"
import style0 from "./messagesCounter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports